var map = {
	"./Base": 721,
	"./Base/": 721,
	"./Base/index": 721,
	"./Base/index.js": 721,
	"./Base/style": 172,
	"./Base/style.js": 172,
	"./Clutch": 420,
	"./Clutch/": 420,
	"./Clutch/index": 420,
	"./Clutch/index.js": 420,
	"./Clutch/renderComponent": 1647,
	"./Clutch/renderComponent.js": 1647,
	"./Clutch/style": 1293,
	"./Clutch/style.js": 1293,
	"./NewUi": 1014,
	"./NewUi/": 1014,
	"./NewUi/index": 1014,
	"./NewUi/index.js": 1014,
	"./NewUi/style": 1294,
	"./NewUi/style.js": 1294,
	"./OldUi": 1015,
	"./OldUi/": 1015,
	"./OldUi/index": 1015,
	"./OldUi/index.js": 1015,
	"./OldUi/renderComponent": 1648,
	"./OldUi/renderComponent.js": 1648,
	"./OldUi/style": 1295,
	"./OldUi/style.js": 1295,
	"./SpireonNew": 1016,
	"./SpireonNew/": 1016,
	"./SpireonNew/index": 1016,
	"./SpireonNew/index.js": 1016,
	"./SpireonNew/renderComponent": 1649,
	"./SpireonNew/renderComponent.js": 1649,
	"./SpireonNew/style": 1296,
	"./SpireonNew/style.js": 1296,
	"./SpireonOld": 1017,
	"./SpireonOld/": 1017,
	"./SpireonOld/index": 1017,
	"./SpireonOld/index.js": 1017,
	"./SpireonOld/renderComponent": 1650,
	"./SpireonOld/renderComponent.js": 1650,
	"./SpireonOld/style": 1297,
	"./SpireonOld/style.js": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;